import { type EvaluationContext, OpenFeature } from '@openfeature/react-sdk'
import { getEnvAsArray } from '@coorum-research/shared-common/utils'

export const FF_PROVIDER_RESEARCH = 'coorum-research-client-provider'

/**
 * データ計測機能を有効とするAccountIdのリスト
 */
const accountIdListForUserActionHistories = getEnvAsArray(import.meta.env, 'VITE_ACCOUNT_ID_LIST_FOR_USER_ACTION_HISTORIES')

/**
 * Feature Flag Key Naming rules
 * - app全体範囲なら、APP_[FEATURE_NAME]
 * - account範囲なら, ACCOUNT_[FEATURE_NAME]
 */
export const featureFlags = {
  // データ計測機能
  ACCOUNT_USER_ACTION_HISTORIES: 'ACCOUNT_USER_ACTION_HISTORIES',
}

export const userClientFlagConfig = {
  [featureFlags.ACCOUNT_USER_ACTION_HISTORIES]: {
    disabled: false,
    variants: {
      on: true,
      off: false,
    },
    defaultVariant: 'off',
    contextEvaluator: (context: EvaluationContext) => {
      if (context.accountId && typeof context.accountId === 'string' &&
        accountIdListForUserActionHistories.includes(context.accountId)) {
        return 'on'
      }
      return 'off'
    },
  },
}

export const setFeatureFlagContextAccountId = async (accountId: string) => {
  const existingContext = OpenFeature.getContext(FF_PROVIDER_RESEARCH)
  await OpenFeature.setContext({
    ...existingContext,
    accountId,
  })
}
